import React from 'react'

const ActiveModuleContext = React.createContext<string | null>(null)
export default ActiveModuleContext